import React, { useEffect } from 'react';
import { Button, Input, Form, Empty, Avatar, Spin } from 'antd';
import { JSXMap, errorCatch, useAuth, GETWITH, Action, QueryDetail, POST, useTranslateContext, QueryParam, Model, ycStorage } from 'fennec-ui';

import Icofont from 'react-icofont';
import { FileSearchOutlined, UserOutlined } from '@ant-design/icons';
import { ycBucket } from '../../../common/Tool';
import Dancer from '../Dancer';
import uuid from 'react-uuid';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { ExclamationCircleOutlined, UploadOutlined } from '@ant-design/icons';
import YImage from '../../../common/YImage';
import { name } from 'dayjs/locale/ru';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

var _ = require('lodash');

const Item = React.forwardRef((props, ref) => {
    const { key, icon, name, selected, style, onMouseEnter, onClick } = props;
    return (
        <div ref={ref} onMouseEnter={onMouseEnter} onClick={onClick} key={key} style={{ width: "100%", display: "flex", justifyContent: "space-between", whiteSpace: "nowrap", textOverflow: "ellipsis", borderRadius: "2px", backgroundColor: (selected) ? "#dcefff" : "transparent", ...style }}>
            <div style={{
                flex: "0 0 15px", marginLeft: "1px",
                marginRight: "3px",
                textAlign: "center"
            }}>{(icon) ? icon : <i className="fa fa-at" style={{ fontSize: "12px" }}></i>}</div>
            <div style={{ flex: "1 1 auto", overflow: "hidden", textOverflow: "ellipsis" }}>{`${name}`}</div>
        </div>
    )
});

const MultilineItem = React.forwardRef((props, ref) => {
    const { key, icon, name, description, image, selected, style, onMouseEnter, onClick } = props;
    return (
        <div
            ref={ref}
            onMouseEnter={onMouseEnter}
            onClick={onClick}
            key={key}
            style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                borderRadius: "2px",
                backgroundColor: (selected) ? "#dcefff" : "transparent",
                ...style
            }}>
            <div style={{
                flex: "0 0 15px", marginLeft: "1px",
                marginRight: "3px",
                textAlign: "center"
            }}>
                {(icon) ? icon : <i className="fa fa-at" style={{ fontSize: "12px" }}></i>}
            </div>
            <div style={{ flex: "1 1 auto", overflow: "hidden", textOverflow: "ellipsis" }}>
                <div style={{ display: "flex", overflow: "hidden", textOverflow: "ellipsis" }}>
                    <div style={{ flex: "0 0 30px", padding: "4px 0px" }}>
                        {image && <img src={image} style={{ width: "30px", marginRight: "5px", borderRadius: "3px" }} />}
                    </div>
                    <div style={{ flex: "1 1 auto", overflow: "hidden", textOverflow: "ellipsis" }}>
                        <div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{`${name}`}</div>
                        {description && <div style={{ fontSize: "10px", color: "#5e5e5e", overflow: "hidden", textOverflow: "ellipsis" }}>{`${description}`}</div>}
                    </div>
                </div>
            </div>
        </div>
    )
});

function SearchObject(props) {
    const auth = useAuth();
    const { value, onChange, filters } = props;

    const SearchItem = (item) => {
        const fallback = "data:image/png;base64,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"
        const getAlias = (item) => (item.alias) ? item.alias : item.objId;
        if (item.festivalID) {
            return {
                rowHeight: 36,
                oID: item.ID,
                key: item.ID || uuid(),
                ID: item?.festivalID,
                name: item?.festival?.nazvanie,
                // detail: `![](${(item?.festival?.afishaMin) ? encodeURI(ycStorage(auth) + ycBucket(auth) + "/" + item?.festival?.afishaMin) : fallback})`,
                // action: (i, { insertAtCursor, start, end, trigger }) => {
                //     insertAtCursor(item?.festival?.nazvanie + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                // },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Фестиваль, ${dayjs(item?.festival?.dataNachala).tz("Europe/Moscow").format('DD.MM.YYYY')}, ${item?.festival?.gorodProvedeniya?.name}`,
                image: (item?.festival?.afishaMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.festival?.afishaMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.meropriyatieID) {
            return {
                rowHeight: 36,
                oID: item.ID,
                key: item.ID || uuid(),
                ID: item?.meropriyatieID,
                name: item?.meropriyatie?.nazvanieMeropriyatiya,
                // detail: `![](${(_.head(item?.meropriyatie?.ssilkiNaFailiMeropriyatie)?.ssilkaMin) ? encodeURI(ycStorage(auth) + ycBucket(auth) + "/" + _.head(item?.meropriyatie?.ssilkiNaFailiMeropriyatie)?.ssilkaMin) : fallback})`,
                // action: (i, { insertAtCursor, start, end, trigger }) => {
                //     insertAtCursor(item?.meropriyatie?.nazvanieMeropriyatiya + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                // },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Мероприятие, ${dayjs(item?.meropriyatie?.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}, ${item?.meropriyatie?.mestoProvedeniya?.name}`,
                image: (_.head(item?.meropriyatie?.ssilkiNaFailiMeropriyatie)?.ssilkaMin) ? ycStorage(auth) + ycBucket(auth) + "/" + _.head(item?.meropriyatie?.ssilkiNaFailiMeropriyatie)?.ssilkaMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.seriyaID) {
            return {
                rowHeight: 36,
                oID: item.ID,
                key: item.ID || uuid(),
                ID: item?.seriyaID,
                name: item?.seriya?.nazvanie,
                // detail: `![](${(item?.seriya?.afishaMin) ? encodeURI(ycStorage(auth) + ycBucket(auth) + "/" + item?.seriya?.afishaMin) : fallback})`,
                // action: (i, { insertAtCursor, start, end, trigger }) => {
                //     insertAtCursor(item?.seriya?.nazvanie + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                // },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Серия, сезон ${item?.seriya?.sezon?.nazvanie}, ${item?.seriya?.urovenSerii?.nazvanie}`,
                image: (item?.seriya?.afishaMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.seriya?.afishaMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.kollektivID) {
            return {
                rowHeight: 36,
                oID: item.ID,
                key: item.ID || uuid(),
                ID: item?.kollektivID,
                name: item?.kollektiv?.nazvanieKollektiva,
                // detail: "",
                // action: (i, { insertAtCursor, start, end, trigger }) => {
                //     insertAtCursor(item?.kollektiv?.nazvanieKollektiva + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                // },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Коллектив, ${item?.kollektiv?.regionalnoeOtdelenie?.nazvanie}`,
                image: (item?.kollektiv?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.organizator?.avatarMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.organizatorID) {
            return {
                rowHeight: 36,
                oID: item.ID,
                key: item.ID || uuid(),
                ID: item?.organizatorID,
                name: item?.organizator?.nazvanie,
                // detail: "",
                // action: (i, { insertAtCursor, start, end, trigger }) => {
                //     insertAtCursor(item?.organizator?.nazvanie + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                // },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Организатор, ${item?.organizator?.regionalnoeOtdelenie?.nazvanie}`,
                image: (item?.organizator?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.organizator?.avatarMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.paraID) {
            return {
                rowHeight: 36,
                oID: item.ID,
                key: item.ID || uuid(),
                ID: item?.paraID,
                name: item?.para?.para?.partner?.firstname + " " + item?.para?.para?.partner?.lastname + " - " +
                    item?.para?.para?.partnersha?.firstname + " " + item?.para?.para?.partnersha?.lastname,
                // detail: "",
                // action: (i, { insertAtCursor, start, end, trigger }) => {
                //     insertAtCursor(item?.para?.para?.partner?.firstname + " " + item?.para?.para?.partner?.lastname + " - " +
                //         item?.para?.para?.partnersha?.firstname + " " + item?.para?.para?.partnersha?.lastname + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                // },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Пара, ${item?.para?.regionalnoeOtdelenie?.nazvanie}`,
                image: (item?.para?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.para?.avatarMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.prepodavatelID) {
            return {
                rowHeight: 36,
                oID: item.ID,
                key: item.ID || uuid(),
                ID: item?.prepodavatelID,
                name: item?.prepodavatel?.user?.firstname + " " + item?.prepodavatel?.user?.lastname,
                // detail: "",
                // action: (i, { insertAtCursor, start, end, trigger }) => {
                //     insertAtCursor(item?.prepodavatel?.user?.firstname + " " + item?.prepodavatel?.user?.lastname + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                // },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Преподаватель, ${item?.prepodavatel?.regionalnoeOtdelenie?.nazvanie}`,
                image: (item?.prepodavatel?.user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.prepodavatel?.user?.avatarMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.regionalnoeOtdelenieID) {
            return {
                rowHeight: 36,
                oID: item.ID,
                key: item.ID || uuid(),
                ID: item?.regionalnoeOtdelenieID,
                name: item?.regionalnoeOtdelenie?.nazvanie,
                // detail: "",
                // action: (i, { insertAtCursor, start, end, trigger }) => {
                //     insertAtCursor(item?.regionalnoeOtdelenie?.nazvanie + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                // },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Региональное отделение`,
                image: (item?.regionalnoeOtdelenie?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.organizator?.avatarMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.shkolaID) {
            return {
                rowHeight: 36,
                oID: item.ID,
                key: item.ID || uuid(),
                ID: item?.shkolaID,
                name: item?.shkola?.nazvanieShkoliTantsev,
                // detail: "",
                // action: (i, { insertAtCursor, start, end, trigger }) => {
                //     insertAtCursor(item?.shkola?.nazvanieShkoliTantsev + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                // },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Школа, ${item?.shkola?.regionalnoeOtdelenie?.nazvanie}`,
                image: (item?.shkola?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.shkola?.avatarMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.sudyaID) {
            return {
                rowHeight: 36,
                oID: item.ID,
                key: item.ID || uuid(),
                ID: item?.sudyaID,
                name: item?.sudya?.user?.firstname + " " + item?.sudya?.user?.lastname,
                // detail: "",
                // action: (i, { insertAtCursor, start, end, trigger }) => {
                //     insertAtCursor(item?.sudya?.user?.firstname + " " + item?.sudya?.user?.lastname + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                // },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Судья, ${item?.sudya?.regionalnoeOtdelenie?.nazvanie}`,
                image: (item?.sudya?.user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.sudya?.user?.avatarMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else if (item.tantsorID) {
            return {
                rowHeight: 36,
                oID: item.ID,
                key: item.ID || uuid(),
                ID: item?.tantsorID,
                name: item?.tantsor?.user?.firstname + " " + item?.tantsor?.user?.lastname,
                // detail: "",
                // action: (i, { insertAtCursor, start, end, trigger }) => {
                //     insertAtCursor(item?.tantsor?.user?.firstname + " " + item?.tantsor?.user?.lastname + " (http://social-dance.club/" + getAlias(item) + ")", start, end)
                // },
                icon: <i className="fa fa-link" style={{ fontSize: "9px", color: "red" }}></i>,
                description: `Танцор, ${item?.tantsor?.regionalnoeOtdelenie?.nazvanie}`,
                image: (item?.tantsor?.user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.tantsor?.user?.avatarMin : fallback,
                render: (item, idx) => <MultilineItem
                    key={item.key}
                    name={item.name}
                    description={item.description}
                    image={item.image}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        } else {
            return {
                key: uuid(),
                name: "Неопознанный объект",
                // detail: "",
                // action: (i, { insertAtCursor, start, end, trigger }) => { },
                icon: <i className="fa fa-question-circle-o" style={{ fontSize: "9px", color: "grey" }}></i>,
                render: (item, idx) => <Item
                    key={item.key}
                    name={item.name}
                    icon={item.icon}
                    style={{ fontSize: "13px" }}
                />
            }
        }
    }

    useEffect(() => {
        if (_.isObject(value) ? value : undefined) {
            setCurrentObject(value)
        }
    }, [value])

    const [currentObject, setCurrentObject] = React.useState();
    useEffect(() => {
        onChange(currentObject)
    }, [currentObject])

    const [loading, setLoading] = React.useState(false);
    const [objects, setObjects] = React.useState([]);
    const requestObjects = (q) => {
        if (q) {
            setLoading(true);
            let permanentFilters = [
                QueryDetail("model"),
                QueryParam("count", "8"),
                QueryParam("q", q)
            ];
            if (filters) {
                permanentFilters.push(...filters);
            }
            GETWITH(auth, `/api/search-filter`, permanentFilters, ({ data }) => {
                // setObjects(data?.map(o => SearchItem(o)));
                setObjects(data?.map(o => SearchItem(o)));
                setLoading(false);
            }, (err) => errorCatch(err, () => setLoading(false)));
        } else {
            setObjects([])
        }
    };
    const _onSearch = (v) => requestObjects(v);
    const onSearch = React.useCallback(_.throttle(_onSearch, 1000, { trailing: true }), []);

    function maskPhone(a) {
        let phone = a?.replace(/^\+/, "")
        phone = phone?.replace(/^7/, "")
        return phone.substr(0, 3) + "*****" + phone.substr(-3)

        // const cleaned = a.replace(/\D/g, ''); // Удаляем все нецифровые символы
        // if (cleaned.length < 6) return phone; // Возвращаем исходное значение, если цифр недостаточно

        // const firstThree = cleaned.substring(0, 3);
        // const lastThree = cleaned.substring(cleaned.length - 3);
        // const stars = '*'.repeat(Math.max(0, cleaned.length - 6)); // Заменяем средние цифры

        // return firstThree + stars + lastThree;
    }
    function maskEmail(email) {
        const parts = email.split('@');
        if (parts.length !== 2) return email; // Если нет "@" или их несколько

        const [localPart, domain] = parts;
        if (localPart.length <= 1) return email; // Не маскируем короткие локальные части

        // Оставляем первый и последний символ локальной части, заменяя остальное на *
        const maskedLocal =
            localPart[0] +
            '*'.repeat(Math.max(0, localPart.length - 2)) +
            localPart.slice(-1);

        return maskedLocal + '@' + domain;
    }

    return (
        <div style={{
            borderRadius: "4px", backgroundColor: "white"
        }}>

            <div>
                <Input allowClear onChange={(e) => onSearch(e.target.value)} style={{ borderRadius: "4px" }} prefix={<Icofont icon="search" style={{ fontSize: "12px" }} />} />
                <Spin spinning={loading}>
                    <div style={{ padding: "9px 2px 0px 2px", display: "flex", flexWrap: "wrap", gap: "5px", alignContent: "flex-start" }}>
                        {(objects && objects.length <= 0) && <div style={{ width: "100%" }}><Empty imageStyle={{ height: "30px" }} description={<span style={{ fontSize: "12px" }}>Нет данных</span>} image={Empty.PRESENTED_IMAGE_SIMPLE} /></div>}
                        {JSXMap(objects, (item, idx) => (
                            <div key={item.ID} className={`object-selector${(item.ID !== undefined && item.ID === currentObject?.ID) ? " selected" : ""}`} onClick={() => setCurrentObject(item)}>
                                <div style={{ display: "flex", textAlign: "left", gap: "5px", lineHeight: "16px" }}>
                                    {item?.render(item, idx)}
                                </div>
                            </div>
                        ))}
                    </div>
                </Spin>
            </div>
        </div>
    )
}
export default function ModernObjectSelection(props) {
    const t = useTranslateContext();
    const { auth, form, submit, filters } = props;
    useEffect(() => {
        form.resetFields();
    }, []);

    return (
        <div>
            <Form
                form={form}
                onFinish={submit}
                labelAlign={"left"}
                layout={"vertical"}
            // initialValues={object}
            >
                <Form.Item
                    label={""}
                    name="object"
                    rules={[{ required: true, message: t('Пожалуйста, выберите один из элементов!') }]}
                >
                    <SearchObject filters={filters} />
                </Form.Item>
            </Form>
        </div>
    );
};